import React from 'react'

import { useSelector } from 'react-redux'
import { selectFilterHotelDates, selectHasFilterMultiDatePicker } from '../../store/geoentity/filter.selectors'
import GoToGeoentityButton from './GoToGeoentityButton'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'

import sListItem from './GeoentityListItem.less'
import sHotelListItem from './GeoentityHotelListItemDetails.less'
import Reviews from './Reviews'
import classNames from 'classnames'

const IncentiveMessage = ({ hasDateFilter }) =>
  hasDateFilter ? (
    __BROWSER__ ? (
      <span className={sHotelListItem.incentiveText}>{'Ajoutez vos dates pour voir les prix et la disponibilité'}</span>
    ) : (
      <span className={sHotelListItem.emptyIncentiveText} />
    )
  ) : (
    <></>
  )

const GeoentityHotelListItemDetails = ({ poi, noExternalButtons }) => {
  const { additionalInfo, reviews } = poi
  const { price, freeCancellation, breakfastIncluded, numberOfNights, numberOfPeople } = additionalInfo
  const hasDateFilter = useSelector(selectHasFilterMultiDatePicker)
  const areFilterDatesFilled = Boolean(useSelector(selectFilterHotelDates))

  const numberOfNightsLabel = numberOfNights > 1 ? 'nuits' : 'nuit'
  const numberOfPeopleLabel = numberOfPeople > 1 ? 'adultes' : 'adulte'

  return (
    <div
      className={classNames(
        sHotelListItem.contentContainer,
        areFilterDatesFilled && sHotelListItem.contentContainerWithPrice
      )}
    >
      <div>
        <div className={sListItem.text}>
          <Reviews reviews={reviews} />
        </div>
        {areFilterDatesFilled ? (
          price?.value && (
            <>
              <span className={sHotelListItem.price}>
                {price.value} {price.currency}
              </span>
              <div className={sHotelListItem.nightText}>
                {numberOfNights && numberOfPeople && (
                  <span>{`pour ${numberOfNights} ${numberOfNightsLabel}, ${numberOfPeople} ${numberOfPeopleLabel}`}</span>
                )}
              </div>
            </>
          )
        ) : (
          <IncentiveMessage hasDateFilter={hasDateFilter} />
        )}

        <div className={sHotelListItem.commoditiesText}>
          {breakfastIncluded && <span>Petit déjeuner inclus</span>}
          {freeCancellation && <span>Annulation gratuite</span>}
        </div>
      </div>
      <div className={classNames(sHotelListItem.button, areFilterDatesFilled && sHotelListItem.buttonWithPrice)}>
        <GoToGeoentityButton poi={poi} tagInfo={{ bouton_clique: "Voir l'offre" }}>
          <RectangleActionButton
            label="Voir l'offre"
            color={COLOR_GREY_EMPTY}
            className={noExternalButtons ? sListItem.fakeButtonLandingPage : sListItem.buttonMoreInfo}
            size={SIZE_MEDIUM}
          />
        </GoToGeoentityButton>
      </div>
    </div>
  )
}

export default GeoentityHotelListItemDetails
